import { useState } from "react";

type SnackbarSeverity = "success" | "error";

interface SnackbarState {
    open: boolean;
    message: string;
    severity: SnackbarSeverity;
    duration: number;
}

export const useSnackbar = () => {
    const [snackbar, setSnackbar] = useState<SnackbarState>({
        open: false,
        message: "",
        severity: "success",
        duration: 4000
    });

    const showSnackbar = (message: string, severity: SnackbarSeverity = "success", duration = 4000) => {
        setSnackbar({
            open: true,
            message,
            severity,
            duration
        });
    };

    const hideSnackbar = () => {
        setSnackbar((prev) => ({ ...prev, open: false }));
    };

    return {
        snackbar,
        showSnackbar,
        hideSnackbar,
    };
};
